module.exports = __webpack_public_path__ + "static-m/img/wenda.2e027bb2.png";